import { SetTeamFeatureUsageRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const setTeamFeatureUsage = (
  req: Partial<SetTeamFeatureUsageRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/SetTeamFeatureUsage',
    body: req,
  }).then((r) => r.body);
